export const GET_PARTNERS = "GET_PARTNERS";

export const GetPartners = () => {
    return { type: GET_PARTNERS };
};
